<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

export default {
  created () {
    // 监听路由变化
    // 根据不同路由跳转不同页面
    if (this.isMobile()) {
      console.log('手机端')
      this.$router.replace({ path: '/m/' }) // 手机路由
    } else {
      console.log('PC端')
    }
  },
  methods: {
    // 该方法用于判断是否进入手机端
    isMobile () {
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
